import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { __rest } from '../../_virtual/_tslib.js';
import React from 'react';
import { lsgPre } from '../../config/prefix.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { fComp } from '../../utils/React.js';
import { ActionPresentation } from '../Action/ActionPresentation.js';
import { hostClass } from './NavigationLink.styles.js';

var NavigationLinkPresentation = fComp(function (props) {
  var _cleanupClassObject, _cleanupClassObject2;
  var id = props.id,
    className = props.className,
    children = props.children,
    noMargin = props.noMargin,
    hasMouseHover = props.hasMouseHover,
    hasKeyboardFocus = props.hasKeyboardFocus,
    secondary = props.secondary,
    otherProps = __rest(props, ["id", "className", "children", "noMargin", "hasMouseHover", "hasKeyboardFocus", "secondary"]);
  return /*#__PURE__*/React.createElement(Host, {
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, "".concat(hostClass), true), _defineProperty(_cleanupClassObject, className, className), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "no-margin"), noMargin), _cleanupClassObject)),
    id: id,
    role: "listitem"
  }, /*#__PURE__*/React.createElement(ActionPresentation, Object.assign({}, otherProps), /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject((_cleanupClassObject2 = {}, _defineProperty(_cleanupClassObject2, "".concat(hostClass, "__secondary"), secondary), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "-inner"), true), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "__hover"), hasMouseHover || hasKeyboardFocus), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "__focus"), hasKeyboardFocus), _cleanupClassObject2))
  }, children)));
});
NavigationLinkPresentation.displayName = "NavigationLinkPresentation";

export { NavigationLinkPresentation };
